module.exports = __webpack_public_path__ + "img/current_hub_line_down_and_up.d7827827.png";